var exports = {
  "k": "x43aef4ae--1d22e4--container",
  "U": "x43aef4ae--1d22e4--arrow",
};

module.exports = exports;
